/**
 * Exporta uma tabela para CSV, no dialeto que o Excel em portugues abre sem
 * perguntar nada.
 *
 * Tres detalhes que parecem manha e nao sao:
 *
 * 1. O ARQUIVO COMECA COM BOM (`\uFEFF`). Sem ele o Excel assume a codificacao do
 *    sistema, e "Condução" chega como "ConduÃ§Ã£o". Quem recebe conclui que o
 *    sistema corrompe acento.
 * 2. QUEBRA DE LINHA E `\r\n`. E o que a especificacao do CSV pede, e o que o Excel
 *    espera; com `\n` sozinho algumas versoes juntam tudo numa linha.
 * 3. CAMPO COM VIRGULA, ASPAS OU QUEBRA VAI ENTRE ASPAS, e aspas interna dobra.
 *    Nome de empresa com virgula ("Transportes Silva, Souza & Cia") deslocaria
 *    todas as colunas a direita dele.
 *
 * O arquivo e montado e baixado no navegador: nenhum dado sai para terceiro, e a
 * exportacao vale exatamente o que a pessoa ja podia ver na tela.
 */

import { salvarArquivo } from './salvarArquivo';

function escapar(valor: string): string {
  const texto = valor ?? '';
  if (texto.includes(',') || texto.includes('"') || texto.includes('\n') || texto.includes('\r')) {
    return `"${texto.replace(/"/g, '""')}"`;
  }
  return texto;
}

export function exportarCsv(
  nomeDoArquivo: string,
  cabecalhos: readonly string[],
  linhas: readonly (readonly string[])[],
): void {
  const conteudo = [
    cabecalhos.map(escapar).join(','),
    ...linhas.map((linha) => linha.map((celula) => escapar(celula ?? '')).join(',')),
  ].join('\r\n');

  const arquivo = new Blob([`\uFEFF${conteudo}`], { type: 'text/csv;charset=utf-8;' });
  salvarArquivo(arquivo, nomeDoArquivo);
}
